export const callError = {
  title: "エラーが発生しました",
  sendMessage: "メッセージを送る",
  autoClose: (args: { count: string | number }) =>
    `${args.count}秒後に自動で閉じます`,
  messages: {
    connectionFailed:
      "接続に失敗しました。しばらくしてから再度お試しください。",
    billingFailed: "決済処理中にエラーが発生しました。",
    fetchFailed:
      "情報の取得に失敗しました。しばらくしてから再度お試しください。",
    videoTimeout:
      "映像を受信できませんでした。電波状況をご確認の上、再度お試しください。",
    videoTimeoutNote: "ポイントは消費されていません。",
    channelEnded: "この配信はすでに終了しています。",
  },
} as const;
